import { useContext } from 'react'
import { ConfigContext } from '@/contexts/configContext'

const useConfig = () => {
    const context = useContext(ConfigContext)

    if (!context)
        throw new Error('useSpace must be used within a ConfigProvider')

    return context
};

export { useConfig }
